var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMicrosoftActiveDirectory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 25,
    fill: "currentColor",
    viewBox: "0 0 24 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "active-directory__Integration=ActiveDirectory, Size=24",
    className: "active-directory__Integration=ActiveDirectory, active-directory__Size=24"
  }, /*#__PURE__*/React.createElement("g", {
    id: "active-directory__Group 206",
    className: "active-directory__Group active-directory__206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "active-directory__path6",
    fill: "#00AAF2",
    d: "M22.972 18.247v4.605c0 .54-.166.65-.679.567-3.436-.511-6.913-.982-10.377-1.466-.623-.083-.845-.304-.845-.982.056-2.448.028-4.91 0-7.385 0-.54.167-.705.707-.705 3.546.027 7.038.027 10.515.027.568 0 .707.222.707.734-.056 1.549-.028 3.07-.028 4.605Z",
    className: "active-directory__path6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "active-directory__path8",
    fill: "#00AAF2",
    d: "M17.084 12.023c-1.746 0-3.491-.028-5.237 0-.54 0-.762-.11-.762-.733.028-2.503.028-4.965 0-7.44 0-.485.166-.65.623-.734 3.575-.511 7.15-1.01 10.724-1.549.623-.083.512.332.512.678 0 2.213.028 4.467 0 6.68 0 .816-.027 1.632 0 2.448.028.511-.166.65-.65.65-1.719-.028-3.465 0-5.21 0Z",
    className: "active-directory__path8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "active-directory__path10",
    fill: "#00AAF2",
    d: "M5.53 12.95h3.907c.416 0 .596.138.596.567v7.69c0 .442-.194.483-.596.442-2.59-.387-5.181-.76-7.758-1.12-.513-.084-.679-.25-.679-.789.028-2.047.028-4.093 0-6.182 0-.511.139-.65.651-.65 1.316.042 2.577.042 3.88.042Z",
    className: "active-directory__path10"
  }), /*#__PURE__*/React.createElement("path", {
    id: "active-directory__path12",
    fill: "#00AAF2",
    d: "M5.53 12.021H1.678c-.484 0-.65-.166-.65-.677.027-2.02.027-4.039 0-6.072 0-.484.138-.65.65-.733a243.46 243.46 0 0 0 7.759-1.12c.596-.083.651.11.651.595v7.357c0 .54-.222.623-.707.623-1.288 0-2.59.027-3.851.027Z",
    className: "active-directory__path12"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosoftActiveDirectory);
export default __webpack_public_path__ + "static/media/MicrosoftActiveDirectory.95f8b446d746c955fe4537db4898c4eb.svg";
export { ForwardRef as ReactComponent };